import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "@ionic/react/css/core.css";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
import { Provider } from "react-redux";
import App from "./App";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import { isPlatform, setupIonicReact } from "@ionic/react";
import * as Sentry from "@sentry/react";


/**
 * Returns a string name for the environment reported to Sentry given
 * the current hostname.
 */
function getSentryEnv() {
  switch (document.location.hostname) {
    case "localhost":
      return "local";
    case "dreams.static.matav.org.il":
      return "production";
    case "dreams-staging.static.matav.org.il":
      return "staging";
    default:
      console.error("SENTRY: unrecogized environment for sentry. Hostname: ", document.hostname);
      return null;
  }
}

Sentry.init({
  dsn: "https://abad7dcae0d9913a194f69f76ff1804a@o4507211185979392.ingest.de.sentry.io/4507260306391120",
  environment: getSentryEnv(),
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
const getConfig = () => {
  const config = {
    swipeBackEnabled: false,
  };
  return config;
};

setupIonicReact(getConfig());

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
